import createFetchClient, { Middleware } from "openapi-fetch";
import createClient from "openapi-react-query";
import { env } from "@shared/config.ts";
import { requestAuthMiddleware } from "../../api/auth-middleware";
import type { paths } from "../api/openapi/journal-service";

const fetchClient = createFetchClient<paths>({
  baseUrl: import.meta.env.DEV
    ? "http://localhost:5173/journal-service"
    : `${env.API_BASE_URL}/journal-service`,
});

export const $journalApi = createClient(fetchClient);

export const {
  useMutation: useJournalMutation,
  useQuery: useJournalQuery,
  queryOptions: journalQueryOptions,
  useSuspenseQuery: useJournalSuspenseQuery,
  useInfiniteQuery: useJournalInfiniteQuery,
} = $journalApi;

const middleware: Middleware = {
  async onRequest({ request }) {
    await requestAuthMiddleware(request);
    return request;
  },
};

fetchClient.use(middleware);

export { fetchClient };
